/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { UsageReportsStore } from '../stores';

export const UsageReportsContext = createContext<UsageReportsStore>({} as UsageReportsStore);
